
import draggable from "vuedraggable";
import { cloneDeep } from "lodash-es";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: { draggable }
})
export default class CustomRuleWrapper extends Vue {
  @Prop({ default: () => [] }) ruleList!: any[];
  list = [];

  changeRuleList() {
    this.$emit("update", this.list);
  }

  @Watch("ruleList", { immediate: true })
  changeList(value: any) {
    this.list = cloneDeep(value);
  }
}
